'use strict';

angular.module('shiftTraderApp')
  .service('EditNoteModal', ['$modal', '$timeout', function ($modal, $timeout) {
    function open(noteId) {
      var modalInstance = $modal.open({
        size: 'modal-md',
        templateUrl: 'views/directives/notes/saNoteEditModal.html',
        controllerAs: 'ModalCtrl',
        controller: ['$scope', '$modalInstance', 'note', function($scope, $modalInstance, note) {
          var vm = this;

          vm.note = note;

          $scope.$on('saNoteCreate:updateSuccessful', function(evt) {
            $rootScope.$broadcast('saNoteCreate:noteEmpty');
            $modalInstance.close();
            evt.stopPropagation();
          });

          vm.dismiss = function() {
            $rootScope.$broadcast('saNoteCreate:noteEmpty');
            $modalInstance.close();
          };

          return vm;
        }],
        resolve: {
          note: ['NotesStore', function(NotesStore) {
            return NotesStore.getByNoteId(noteId);
          }]
        }
      });

      modalInstance.result.then(function(result) {
        // Success
      }, function(result) {
        // Cancel (probably won't happen)
      })
    }

    return {
      open: open
    };
  }]);
